'use client';

import { useQuery } from '@tanstack/react-query';
import { caseAPI } from '@/lib/api';
import Link from 'next/link';

interface CaseListProps {
  limit?: number;
}

export default function CaseList({ limit = 5 }: CaseListProps) {
  const { data, isLoading } = useQuery({
    queryKey: ['cases', limit],
    queryFn: () =>
      caseAPI.getList({
        status: 'published',
        limit,
      }),
  });

  if (isLoading) {
    return (
      <div className="uc_post_list space-y-3">
        {[...Array(limit)].map((_, i) => (
          <div key={i} className="uc_post_list_box bg-gray-200 animate-pulse h-24 rounded" />
        ))}
      </div>
    );
  }

  if (!data?.data || data.data.length === 0) {
    return <p className="text-text-light">暂无案例</p>;
  }

  return (
    <div className="uc_post_list uc-items-wrapper">
      {data.data.map((caseItem) => {
        return (
          <div key={caseItem.id} className="uc_post_list_box">
            <div className="uc_post_list_content">
              <div className="uc_post_list_content_inside">
                <h5 className="uc_post_list_title">
                  <Link href={`/case/${caseItem.slug}`}>
                    {caseItem.title}
                  </Link>
                </h5>
                <p className="uc_post_list_date">
                  {new Date(caseItem.createdAt).toLocaleDateString('zh-CN')}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

